<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.description}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button  mat-dialog-close="true">Ok</button>
</div>
